import axios from 'axios';
import Constatnt from '../config/constant';
import { Decryption, Encryption, logoutRedirection } from '../config/common';


const AxiosClientApi = axios.create({
    baseURL: Constatnt.API_BASE_URL,
    headers: {
        'Accept-Language': Constatnt.language,
        'API-KEY': Encryption(Constatnt.API_KEY, true),
        'Content-Type': 'text/plain',
        'type':'admin',
        'app': 'A'
    }

});

console.log("aaaaaaaaaaaaaaaaa",Encryption(localStorage.getItem("Ptoken"), true));

// request AxiosClient
AxiosClientApi.interceptors.request.use(function (request) {
    request.headers['token'] = Encryption(localStorage.getItem("Ptoken"), true);
    request.headers['Accept-Language'] = Constatnt.language;
//   console.log('token milaaaaa', request.headers['token'] );
//   console.log('=====',Encryption(localStorage.getItem("Ptoken"), true));
    return request;
});


AxiosClientApi.interceptors.response.use(
    function (response) {
       
        return Decryption(response.data)
    },
    function (error) {
       
        if (error?.response?.status === 401) {
            logoutRedirection();
        }
     return Decryption(error.response.data);
     
    }
);

export default AxiosClientApi;
